import { createAsyncThunk } from "@reduxjs/toolkit";
import { PropertyFeature } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindPropertyFeature, GetPropertyFeature } from "../../propertyFeature/api/interface";

export const findSelectPropertyFeature = createAsyncThunk(
  "selectPropertyFeature/findSelectPropertyFeature",
  async (values: FindPropertyFeature, { rejectWithValue }) => {
    try {
      const response = await PropertyFeature.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectPropertyFeature = createAsyncThunk(
  "selectPropertyFeature/searchSelectPropertyFeature",
  async (values: FindPropertyFeature, { rejectWithValue }) => {
    try {
      const response = await PropertyFeature.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectPropertyFeature = createAsyncThunk(
  'selectPropertyFeature/getSelectPropertyFeature',
  async ({ id }: GetPropertyFeature, { rejectWithValue }) => {
    try {
      const response = await PropertyFeature.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
